"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTypes = void 0;
var InputTypes;
(function (InputTypes) {
    InputTypes["LIST"] = "list";
    InputTypes["TEXT"] = "text";
    InputTypes["TEXT_IMAGE"] = "textimg";
    InputTypes["SINGLE"] = "single";
    InputTypes["LIST_NO_SUGGEST"] = "list_no_suggest";
    InputTypes["LIST_LONG_TEXT"] = "list_long_text";
})(InputTypes = exports.InputTypes || (exports.InputTypes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT250b2xvZ3kuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHVibGljL2ludGVyZmFjZXMvT250b2xvZ3kudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsSUFBWSxVQU9YO0FBUEQsV0FBWSxVQUFVO0lBQ3BCLDJCQUFhLENBQUE7SUFDYiwyQkFBYSxDQUFBO0lBQ2Isb0NBQXNCLENBQUE7SUFDdEIsK0JBQWlCLENBQUE7SUFDakIsaURBQW1DLENBQUE7SUFDbkMsK0NBQWlDLENBQUE7QUFDbkMsQ0FBQyxFQVBXLFVBQVUsR0FBVixrQkFBVSxLQUFWLGtCQUFVLFFBT3JCIn0=